module.exports = __webpack_public_path__ + "media/images/smart_phone/toplogo_09-5ea0fb3073c7f823c509c736c3df7807.png";